import React from "react";

export class DownloadModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
     
    }
  }
   


   
  render() {
    return (

      <React.Fragment>
        {this.props.status &&
          <>
            <div class="modal fade in " id="editdata" role="dialog">
              <div class="modal-dialog">

                <div class="modal-content">
                <div class="modal-header">
                <h4 class="modal-title">Download Records</h4>
                                         <button type="button" class="close" onClick={this.props.closeDownload} >&times;</button>
                                    </div>
                  <div class="modal-body mod-body">
                    <h5 >Please click on Download button to download your Records</h5>
                    {this.props && 
                        <button class="btnDefault"><a href={this.props.src} target="_blank" download> Download</a></button>
                    //     <form method="get" action={this.props.src}>
                    //     <button type="submit">Download!</button>
                    //  </form>
                    }
                  </div>
                  <div class="model-btn text-center mb-3">
                    
      
                    

                    
                  </div>
                </div>



              </div>

            </div>
          </>
        }
      </React.Fragment>


    )
  }
}

export default DownloadModel;